import React, { Component } from 'react'
import _ from '/home/ps/root'
import PropTypes from 'prop-types'
// import { ConnectedRouter } from 'connected-react-router'
// import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux'
import View from '../view'
import MasterView from './view/'
// import ErrorBoundary from './error-boundry';
// import '../../../style/style.css';
import '../../../../../master.css';
// import './favicon.ico'; // i wrote that
// import { hot } from "react-hot-loader"
export const ID = 'masterviews'
class MasterViews extends View {
  render() {
    const {store, ...prop} = this.props;
    const p = {...prop}
    // <ConnectedRouter history={history}>
    // <React.StrictMode>
    // </React.StrictMode>
    // </ConnectedRouter>
    return (
      <Provider store={store}>
        <MasterView {...p}/>
      </Provider>
    )
  }
}
MasterViews.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  // remount: PropTypes.func.isRequred,
}
// export default hot(module)(MasterViews)
export default MasterViews
